import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.5,4.12a8.16,8.16,0,0,1-2,2q0,0.17,0,.51a11.06,11.06,0,0,1-.46,3.13,11.31,11.31,0,0,1-1.39,3,11.78,11.78,0,0,1-2.22,2.54,9.9,9.9,0,0,1-3.11,1.76,11.38,11.38,0,0,1-3.89.66A10.81,10.81,0,0,1,.5,16a8.33,8.33,0,0,0,.94,0,7.62,7.62,0,0,0,4.83-1.66,3.9,3.9,0,0,1-3.64-2.7,4.93,4.93,0,0,0,.74.06,4,4,0,0,0,1-.13,3.83,3.83,0,0,1-2.24-1.34,3.76,3.76,0,0,1-.89-2.48v0A3.86,3.86,0,0,0,3,8.2,3.89,3.89,0,0,1,1.77,6.82,3.79,3.79,0,0,1,1.3,5a3.82,3.82,0,0,1,.53-2A11,11,0,0,0,5.38,5.87a10.85,10.85,0,0,0,4.48,1.2,4.33,4.33,0,0,1-.1-0.89A3.75,3.75,0,0,1,10.9,3.42a3.9,3.9,0,0,1,5.6.09A7.64,7.64,0,0,0,19,2.57a3.78,3.78,0,0,1-1.71,2.15A7.76,7.76,0,0,0,19.5,4.12Z"
});

var SvgTwitter = function SvgTwitter(props) {
  return _ref;
};

export default SvgTwitter;